import React from 'react'
import MapComponent from '../../../../../../../common/components/organisme/MapComponent/MapComponent'


export  interface PoleLocalisationViewProps {
    lat ?: number
    lng ?: number
}

export default function PoleLocalisationView({lat, lng}: PoleLocalisationViewProps) {

    if (!lat || !lng) {
        return (
            <></>)
        }
  return (
   
    <MapComponent
    style={{ height: "100%", width: "100%", borderRadius: "20px" }}
        center={[lat, lng]}
        pinList={[{
            position: [lat, lng],
            name: 'poteau (' + lat + ', ' + lng + ')'
        }]}

    />
  )
}
